export const projectName = 'planirovshchiki3d';

export const storageSessionKey = `${projectName}_sessionId`;
